import { Eye } from "lucide-react";

export function EntryClosed({ what, noSide = false, testid = "entry-closed" }) {
  return (
    <div className="mt-6 flex items-start gap-3 rounded-xl border border-amber-300 bg-amber-50 p-5 text-amber-900" data-testid={testid}>
      <Eye className="mt-0.5 h-5 w-5 shrink-0" />
      <div>
        <p className="font-semibold" data-testid={`${testid}-title`}>{noSide ? "View only." : "Entry is closed right now. View only."}</p>
        <p className="text-sm">{noSide ? `To add a ${what}, open it from General Council or MWJK in the menu.` : `You can see and open your church's ${what} records, but you cannot add, edit or delete them until the Master Admin opens entry.`}</p>
      </div>
    </div>
  );
}
